import classes from "../ThousandPropertiesNewRails.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import Chevron from "@Icons/Chevron";
import wrapperHOC from "@Utils/wrapperHOC";

interface HeaderProps {
  title: string;
  subTitle?: string;
  isDesktop: boolean;
  showSeeAll: boolean;
  isWhitelabel: boolean;
  handleExploreMore: () => void;
}

const Header: React.FC<HeaderProps> = ({
  title,
  subTitle,
  isDesktop,
  showSeeAll,
  isWhitelabel,
  handleExploreMore,
}) => {
  const { t } = useTranslationHook();

  return (
    <div className={isDesktop ? classes.titleBarDesktop : classes.titleBar}>
      <div className={classes.titleBarContainer}>
        <h2 className={classes.sectionTitle}>{t(title)}</h2>
        {showSeeAll && isWhitelabel && isDesktop && (
          <div
            className={classes.seeAllBtn}
            role="button"
            onClick={handleExploreMore}
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleExploreMore()}
          >
            {t("whitelabel.home.collections.seeall")}
            <div className={classes.chevron}>
              <Chevron height="12" width="12" />
            </div>
          </div>
        )}
      </div>
      {subTitle && <h5 className={classes.sectionSubTitle}>{t(subTitle)}</h5>}
    </div>
  );
};

export default wrapperHOC(Header, {
  componentName: "Header-thousandProperty",
  showForChina: true,
});
